import React from "react";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";


import EventFAQs from "./EventFAQs";
import WhatsIncluded from "./WhatsIncluded";
import EventCoverImage from "./EventCoverImage";
import EventDetailsCard from "./EventDetailsCard";
import EventDescription from "./EventDescription";
import { Footer, Header } from "../../../components";
import { StyledDetailsContainerDesktop } from "../../../components/StyledComponents/PageDetailsContainer";
import EventGallery from "./EventGallery";

export function EventDetailsPage() {

    return <React.Fragment>
        <Header />
        <StyledDetailsContainerDesktop>
            <Grid container spacing={4}>
                <Grid item xs={12} sm={8}>
                    <Stack spacing={5}>
                        <EventCoverImage />
                        <EventDescription />
                        <WhatsIncluded />
                        <EventFAQs />
                        <EventGallery/>
                    </Stack>
                </Grid>
                <Grid item sm={4} xs={12}>
                    <EventDetailsCard />
                </Grid>
            </Grid>
        </StyledDetailsContainerDesktop>
        <Footer />
    </React.Fragment>
}